var _path, _path2, _mask, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 22.25V10.1374L20.8863 13.4101C21.7136 13.7647 22.25 14.5781 22.25 15.4782V22.25H13.25Z",
    stroke: "#00725F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.5V6M16 8.5V6M20 3.5V6M20 8.5V6M16 6H20",
    stroke: "#00725F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_38_7755",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C1.89543 1 1 1.89543 1 3V23H5V20.5C5 19.1193 6.11929 18 7.5 18C8.88071 18 10 19.1193 10 20.5V23H14V3C14 1.89543 13.1046 1 12 1H3Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23H-0.5V24.5H1V23ZM5 23V24.5H6.5V23H5ZM10 23H8.5V24.5H10V23ZM14 23V24.5H15.5V23H14ZM2.5 3C2.5 2.72386 2.72386 2.5 3 2.5V-0.5C1.067 -0.5 -0.5 1.067 -0.5 3H2.5ZM2.5 23V3H-0.5V23H2.5ZM5 21.5H1V24.5H5V21.5ZM6.5 23V20.5H3.5V23H6.5ZM6.5 20.5C6.5 19.9477 6.94771 19.5 7.5 19.5V16.5C5.29086 16.5 3.5 18.2909 3.5 20.5H6.5ZM7.5 19.5C8.05229 19.5 8.5 19.9477 8.5 20.5H11.5C11.5 18.2909 9.70914 16.5 7.5 16.5V19.5ZM8.5 20.5V23H11.5V20.5H8.5ZM14 21.5H10V24.5H14V21.5ZM12.5 3V23H15.5V3H12.5ZM12 2.5C12.2761 2.5 12.5 2.72386 12.5 3H15.5C15.5 1.067 13.933 -0.5 12 -0.5V2.5ZM3 2.5H12V-0.5H3V2.5Z",
    fill: "#00725F",
    mask: "url(#path-3-inside-1_38_7755)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 3,
    height: 3,
    fill: "#00725F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 3,
    height: 3,
    fill: "#00725F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 3,
    height: 3,
    fill: "#00725F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 3,
    height: 3,
    fill: "#00725F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 3,
    height: 3,
    fill: "#00725F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 3,
    height: 3,
    fill: "#00725F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 2,
    height: 2,
    fill: "#00725F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 2,
    height: 2,
    fill: "#00725F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 2,
    height: 2,
    fill: "#00725F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 2,
    height: 2,
    fill: "#00725F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.66dd32f7a864e5b5e009c626539c3424.svg";
export { ForwardRef as ReactComponent };